import React, { useEffect, useContext, useState, useCallback } from "react";
import "./ScoreTable.scss";
import { ProfileContext } from "../../contexts/APIProvider";
import { showUserPerformance } from "../../apis/userDetailsApi";

interface User {
  username: string;
  rank: number;
  exp_meter: number;
  level: number;
}

interface LeaderboardData {
  username: string;
  rank: number;
  exp_meter: number;
  level: number;
}

const ScoreTable: React.FC<{ user: User }> = ({ user }) => {
  return (
    <div>
      <div style={{ flexGrow: 4 }}>
        <section className="card-info card-section">
          <section className="user row">
            <h1 className="user-header">{user?.username.toUpperCase()}</h1>
          </section>

          <section className="statistics">
            <article className="statistic">
              <h4 className="statistic-title">Rank</h4>
              <h3 className="statistic-value">{user?.rank}</h3>
            </article>

            <article className="statistic">
              <h4 className="statistic-title">Score</h4>
              <h3 className="statistic-value">{user?.exp_meter}</h3>
            </article>
          </section>

          <div className="dial">
            <h2 className="dial-title">{user?.level}</h2>
            <h3 className="dial-value">Level</h3>
          </div>
        </section>
      </div>
    </div>
  );
};

const ScoreTableList: React.FC = () => {
  const { leaderBoard, setLeaderBoard } = useContext(ProfileContext);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchData = useCallback(async () => {
      try {
        const response = await showUserPerformance();
        setLeaderBoard(response.data as LeaderboardData);
      } catch (error) {
        setLeaderBoard(null);
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
  }, [setLeaderBoard]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return <div>{leaderBoard ? <ScoreTable user={leaderBoard} /> : null}</div>;
};

export default ScoreTableList;
